<template>
  <v-container class="ma-0 pa-0">
    <v-alert v-if="poll && !poll.enabled_voting" type="warning" prominent>Hlasovanie bolo zastavené</v-alert>

    <v-alert v-else-if="questionID && !questions[0].enabled_voting" type="warning" prominent>Hlasovanie bolo
      zastavené</v-alert>

    <v-btn elevation="2" fab absolute small @click="$router.go(-1)" v-show="!$vuetify.breakpoint.smAndDown"><v-icon
        color="primary">mdi-arrow-left-bold</v-icon></v-btn>

    <div v-if="!questionID">
      <v-row dense>
        <v-col align="center">
          <span class="text-h4">
            {{ category.name }} <v-icon large v-if="category.private">mdi-file-hidden</v-icon>
          </span>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col align="center">
          <span class="text-subtitle">
            {{ category.sub_name }}
          </span>
        </v-col>
      </v-row>
      <v-row dense justify="space-between">
        <v-col align="center" cols="1">
        </v-col>

        <v-col align="center" cols="10">
          <div v-if="poll" class="d-flex justify-center align-center">
            <span class="text-h5 primary--text font-weight-medium">{{ poll.name }} <v-icon
                v-if="poll.private">mdi-file-hidden</v-icon></span>
            <InlineNotificationControl v-if="isAuthenticated && poll.id" :pollId="poll.id" class="ml-2" />
          </div>
        </v-col>
        <v-col align="right" align-self="right" cols="1">
          <share-component :name="category.name" :pageUrl="pageUrl"></share-component>
        </v-col>
      </v-row>

      <v-row no-gutters align="center" justify="space-between">
        <v-col cols="12" md="4" lg="5">
          <v-text-field v-model="search" label="Vyhľadaj" clearable></v-text-field>
        </v-col>
        <v-col cols="12" md="5" lg="5" class="pl-md-10" align="left">
          Zoradiť podľa
          <v-btn text color="primary" class="pa-0 ma-0" @click="changeSortYes()">
            ÁNO<div v-show="sort == 'rank_yes' || sort == '-rank_yes'">
              <v-icon v-if="sort == '-rank_yes'">mdi-arrow-down</v-icon><v-icon
                v-else-if="sort == 'rank_yes'">mdi-arrow-up</v-icon>
            </div>
          </v-btn>

          <v-btn text color="primary" class="pa-0 ma-0" @click="changeSortNo()">
            NIE<div v-show="sort == 'rank_no' || sort == '-rank_no'">
              <v-icon v-if="sort == '-rank_no'">mdi-arrow-down</v-icon><v-icon
                v-else-if="sort == 'rank_no'">mdi-arrow-up</v-icon>
            </div>
          </v-btn>

          <v-btn text color="primary" class="pa-0 ma-0" @click="changeSortAll()">
            Spolu<div v-show="sort == 'hodnotenie' || sort == '-hodnotenie'">
              <v-icon v-if="sort == '-hodnotenie'">mdi-arrow-down</v-icon><v-icon
                v-else-if="sort == 'hodnotenie'">mdi-arrow-up</v-icon>
            </div>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="3" md="3" lg="2" align="right">
          <v-btn v-if="filter_favorite" text color="amber amber-darken-4" @click="filter_favorite = false">
            Iba obľúbené &nbsp;<v-icon>mdi-star</v-icon>
          </v-btn>

          <v-btn v-else text color="amber amber-darken-4" @click="filter_favorite = true">
            Iba obľúbené &nbsp;<v-icon>mdi-star-outline</v-icon>
          </v-btn>

        </v-col>
      </v-row>

      <v-row justify="space-between" align="center" no-gutters>
        <v-col cols="12" md="5" align="left">
          <v-menu ref="menu" v-model="dateFilterMenu" :close-on-content-click="false" :return-value.sync="dates"
            transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateRangeText" label="Filtrovať podľa dátumu" prepend-icon="mdi-calendar"
                append-icon="mdi-close" @click:append="dates = []" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="dates" multiple no-title scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateFilterMenu = false">
                Zmazať
              </v-btn>

              <v-btn text color="primary" @click="$refs.menu.save(dates)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="6" align="right">
          <v-btn v-if="filter_voted" text @click="filter_voted = false">
            Iba neodhlasované &nbsp;<v-icon>mdi-check</v-icon>
          </v-btn>

          <v-btn v-else text @click="filter_voted = true">
            Iba neodhlasované &nbsp;<v-icon small>mdi-check-outline</v-icon>
          </v-btn>

        </v-col>
      </v-row>
    </div>

    <v-divider v-if="!questionID"></v-divider>

    <v-container v-if="loading">
      <v-row justify="center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
    </v-container>

    <template v-else>
      <div v-for="question in questions" v-bind:key="question.id" class="mb-6" :id="question.id">
        <v-card elevation="2" class="rounded-lg overflow-hidden">
          <!-- Header: Question Name and Actions -->
          <v-card-title class="d-flex align-start pt-4 pb-2">
            <div class="mr-auto" style="width: 85%;">
              <div class="text-caption grey--text mb-1" v-if="!questionID">Otázka #{{ question.order }}</div>
              <poll-question-click-desc :name="question.first_field" :description="question.description_click"
                class="text-h6 font-weight-bold" style="line-height: 1.3"></poll-question-click-desc>
            </div>
            <div class="d-flex flex-column align-end">
              <share-component :name="question.first_field" :pageUrl="pageUrl + '#' + question.id"></share-component>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on"
                    @click="question.user_favorite ? removeFavorite(question.id) : addFavorite(question.id)"
                    class="mt-1">
                    <v-icon :color="question.user_favorite ? 'amber darken-4' : 'grey lighten-1'">
                      {{ question.user_favorite ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ question.user_favorite ? 'Zrušiť obľúbené' : 'Pridať obľúbené' }}</span>
              </v-tooltip>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pt-4">
            <!-- Context and Description -->
            <v-row>
              <v-col cols="12" md="8">
                <poll-question-sources v-show="question.sources" name="Povedali, napísali niekde inde"
                  :description="question.sources" class="mb-3"></poll-question-sources>
                <poll-description v-if="question.description" name="Doplnenie témy"
                  :description="question.description"></poll-description>
              </v-col>

              <!-- Author Info: Moved to side or bottom -->
              <v-col cols="12" md="4">
                <v-card outlined class="pa-2">
                  <div class="d-flex align-center">
                    <v-list-item-avatar color="grey darken-3" class="my-0 mr-3">
                      <v-img v-if="question.created_by.photo" :src="question.created_by.photo"
                        @click="selectedItem = question.created_by.photo" style="cursor: pointer"></v-img>
                      <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <div>
                      <div class="d-flex align-center">
                        <span class="font-weight-medium text-body-2">{{ question.created_by.first_name }} {{
                          question.created_by.last_name }}</span>
                        <InlineNotificationControl v-if="isAuthenticated && question.created_by.id"
                          :moderatorId="question.created_by.id" class="ml-2" />
                      </div>
                      <div class="text-caption grey--text">{{ question.created_by.address_town }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Media and Voting -->
            <v-row class="mt-4">
              <!-- Media Column -->
              <v-col v-if="question.type == 'ZRKADLA' || question.type == 'TRIBUNAL'" cols="12" md="6">
                <v-img v-if="question.photo" :src="question.photo" class="rounded-lg mb-2" max-height="400"
                  contain></v-img>
                <div v-else-if="question.video" class="player-container rounded-lg overflow-hidden">
                  <video controls style="width: 100%; border-radius: 8px;">
                    <source :src="question.video" type="video/mp4">
                  </video>
                </div>
              </v-col>
              <v-col v-else-if="question.type == 'NAZORY'" cols="12" md="6">
                <poll-nazory :question="question"></poll-nazory>
              </v-col>

              <!-- Voting Buttons Column -->
              <v-col cols="12"
                :md="(question.type == 'ZRKADLA' || question.type == 'TRIBUNAL' || question.type == 'NAZORY') ? 6 : 12">
                <v-alert v-if="!question.enabled_voting" type="warning" dense border="left" colored-border
                  elevation="2">
                  Hlasovanie zastavené
                </v-alert>

                <div class="d-flex flex-column gap-2">
                  <poll-voting name="ÁNO" :selected="question.user_voted_type == 'YES_YES'"
                    :votes="question.votes_yes_yes_count" :totalVotes="question.votes_total_count" color="success"
                    type="YES_YES" :questionID="question.id" @sync-child="syncChild" class="mb-2"> </poll-voting>

                  <poll-voting v-show="question.type == 'ZRKADLA' || question.type == 'NAZORY'" name="Skôr ÁNO"
                    :selected="question.user_voted_type == 'YES_NO'" :votes="question.votes_yes_no_count"
                    :totalVotes="question.votes_total_count" color="success lighten-2" type="YES_NO"
                    :questionID="question.id" @sync-child="syncChild" class="mb-2"> </poll-voting>

                  <poll-voting name="ZDRŽÍM SA" :selected="question.user_voted_type == 'NEUTRAL'"
                    :votes="question.votes_neutral_count" :totalVotes="question.votes_total_count" color="primary"
                    type="NEUTRAL" :questionID="question.id" @sync-child="syncChild" class="mb-2"> </poll-voting>

                  <poll-voting v-show="question.type == 'ZRKADLA' || question.type == 'NAZORY'" name="Skôr NIE"
                    :selected="question.user_voted_type == 'NO_YES'" :votes="question.votes_no_yes_count"
                    :totalVotes="question.votes_total_count" color="error lighten-2" type="NO_YES"
                    :questionID="question.id" @sync-child="syncChild" class="mb-2"> </poll-voting>

                  <poll-voting name="NIE" :selected="question.user_voted_type == 'NO_NO'"
                    :votes="question.votes_no_no_count" :totalVotes="question.votes_total_count" color="error"
                    type="NO_NO" :questionID="question.id" @sync-child="syncChild"> </poll-voting>
                </div>
              </v-col>
            </v-row>

            <!-- Trust Stats for ZRKADLA -->
            <div v-show="question.type == 'ZRKADLA'" class="grey lighten-4 rounded pa-3 mt-4">
              <v-row no-gutters align="center" justify="center">
                <v-col cols="12" md="4" class="text-center font-weight-bold">
                  <div v-if="getPercentageAll(question) > 0" class="text-caption text-uppercase success--text">VÄČŠINA
                    ZA</div>
                  <div v-else-if="getPercentageAll(question) < 0" class="text-caption text-uppercase error--text">
                    VÄČŠINA PROTI
                  </div>
                  <div v-else class="text-caption text-uppercase primary--text">REMÍZA</div>

                  <span v-if="getPercentageAll(question) > 0" class="success--text text-h5">{{
                    getPercentageAll(question)
                    }}%</span>
                  <span v-else-if="getPercentageAll(question) < 0" class="error--text text-h5">{{
                    Math.abs(getPercentageAll(question)) }}%</span>
                  <span v-else class="primary--text text-h5">0%</span>
                </v-col>
                <v-col cols="6" md="4" class="text-center border-right" style="border-color: #ddd;">
                  <div class="text-caption text-uppercase grey--text">Ranking Dôvery</div>
                  <div class="text-h6">
                    {{ question.calculation_reversed ? question.rank_no : question.rank_yes }} / {{
                      question.ranks_total_no }}
                  </div>
                </v-col>
                <v-col cols="6" md="4" class="text-center">
                  <div class="text-caption text-uppercase grey--text">Ranking Nedôvery</div>
                  <div class="text-h6">
                    {{ question.calculation_reversed ? question.rank_yes : question.rank_no }} / {{
                      question.ranks_total_no }}
                  </div>
                </v-col>
              </v-row>
            </div>

          </v-card-text>

          <v-card-actions class="grey lighten-5 pa-3 poll-actions">
            <v-btn v-if="!questionID && question.sub_questions.length > 0" text small color="primary"
              :to="'/poll_category/' + categoryID + '/poll_sub_questions/' + question.id + '/'">
              <v-icon left>mdi-file-tree</v-icon>
              Súvisiace otázky ({{ question.sub_questions.length }})
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn v-if="question.enabled_discussion" text color="primary"
              :to="'/poll_question_discussion/' + question.id">
              <v-icon left>mdi-message-text</v-icon>
              Diskusia ({{ question.comments_total }})
            </v-btn>

            <!-- Admin detail if needed -->
            <poll-question-detail class="poll-actions-detail" :question="question"></poll-question-detail>
          </v-card-actions>
        </v-card>
      </div>
    </template>
    <v-divider></v-divider>
    <v-overlay v-if="selectedItem" @click="selectedItem = null">
      <v-container>
        <v-row justify="center">
          <v-col align="center">
            <v-img max-width="300px" max-height="300px" :src="selectedItem" contain></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import { APIService } from "@/http/APIService.js";

import PollVoting from "@/components/poll/PollVoting.vue";
import PollNazory from "./PollNazory.vue";
import PollDescription from "./PollDescription.vue";
import PollQuestionDetail from './PollQuestionDetail.vue';
import PollQuestionSources from './PollQuestionSources.vue';
import PollQuestionClickDesc from './PollQuestionClickDesc.vue';

import moment from 'moment';
import ShareComponent from '@/components/ShareComponent.vue';
import InlineNotificationControl from "@/components/notifications/InlineNotificationControl.vue";

const apiService = new APIService();

import VueCoreVideoPlayer from 'vue-core-video-player'
import Vue from 'vue';

Vue.use(VueCoreVideoPlayer)

export default {
  name: 'Poll',
  inheritAttrs: true,

  components: {
    PollVoting,
    PollNazory,
    PollDescription,
    PollQuestionDetail,
    PollQuestionSources,
    PollQuestionClickDesc,
    ShareComponent,
    InlineNotificationControl
  },

  props: {
    pollID: { type: Number },
    categoryID: { type: Number },
    questionID: { type: Number },
  },

  data() {
    return {
      loading: true,
      sync: false,
      search: "",
      filters: [],

      questions: [],
      category: {},
      poll: null,
      count: 0,

      sort: "-order",
      filter_favorite: false,
      filter_voted: false,
      dates: [],

      dateFilterMenu: false,
      dialShare: false,
      selectedItem: null,
    }
  },

  computed: {
    ...mapGetters("auth", [
      "isAuthenticated",
      "username",
      "isVerified",
      "isVerifiedBank",
      "isVerifiedSmsEmail",
      "isStaff",
      "getMemberStatus",
      "firstName",
      "lastName",
      "gender",
      "user_id"
    ]),

    ...mapGetters("settings", ["getSettings"]),

    getMobileClasses() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "";
      } else {
        return "pl-5";
      }
    },


    dateRangeText() {
      if (this.dates.length > 1)
        return `Od ${moment(this.dates[0]).format("DD.MM.YYYY")} do ${moment(this.dates[1]).format("DD.MM.YYYY")}`;
      else
        return "";
    },

    pageUrl() {
      return window.location.origin + this.$route.path;
    }
  },


  events: {},

  watch: {
    loading() {
      if (!this.loading && this.$route.hash) {
        setTimeout(() => {
          const element = document.getElementById(this.$route.hash.replace("#", ""));
          element.scrollIntoView({ block: "center", inline: "nearest" });
        }, 500);
      }
    },
    sync() {
      this.getQuestions();
    },

    filter_favorite() {
      localStorage.setItem("poll_filter_favorite", this.filter_favorite ? "true" : "false");
      this.getQuestions();
    },

    filter_voted() {
      this.getQuestions();
    },

    dates() {
      if (this.dates.length == 0 || this.dates.length == 2)
        this.getQuestions();
    },


    search() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getQuestions();
      }, 500);
    },

    sort() {
      this.getQuestions();
    },
  },

  mounted: function () {
    if (localStorage.getItem("poll_filter_favorite") === "true") {
      this.filter_favorite = true;
    }

    this.getQuestions();

    if (!this.questionID) {
      this.getCategory();
      this.getPoll();
    }
  },

  methods: {
    getVotesWithoutNeutral(question) {
      return question.votes_yes_yes_count + 0.5 * question.votes_yes_no_count + question.votes_no_no_count + 0.5 * question.votes_no_yes_count;
    },

    getPercentageAll(question) {
      let tmp = 0;
      if (question.calculation_reversed)
        tmp = (question.votes_no_no_count + 0.5 * question.votes_no_yes_count - question.votes_yes_yes_count - 0.5 * question.votes_yes_no_count) / this.getVotesWithoutNeutral(question) * 100;
      else
        tmp = (question.votes_yes_yes_count + 0.5 * question.votes_yes_no_count - question.votes_no_no_count - 0.5 * question.votes_no_yes_count) / this.getVotesWithoutNeutral(question) * 100;

      return Math.round((tmp ? tmp : 0 + Number.EPSILON) * 100) / 100;
    },

    removeFavorite(id) {
      apiService.generalPollQuestionRemoveFavorite(id).then(() => {
        this.getQuestions();
      });
    },

    addFavorite(id) {
      apiService.generalPollQuestionAddFavorite(id).then(() => {
        this.getQuestions();
      });
    },

    changeSortYes() {
      if (this.sort == "rank_yes")
        this.sort = '-rank_yes';
      else if (this.sort == "-rank_yes")
        this.sort = "-order";
      else
        this.sort = 'rank_yes';
    },

    changeSortNo() {
      if (this.sort == "rank_no")
        this.sort = '-rank_no';
      else if (this.sort == "-rank_no")
        this.sort = "-order";
      else
        this.sort = 'rank_no';
    },

    changeSortAll() {
      if (this.sort == "hodnotenie")
        this.sort = '-hodnotenie';
      else if (this.sort == "-hodnotenie")
        this.sort = "-order";
      else
        this.sort = 'hodnotenie';
    },


    syncChild() {
      this.getQuestions();
    },
    getCategory() {
      apiService.getGeneralPollCategory(this.categoryID).then(response => {
        this.category = response;
      })
    },

    getPoll() {
      apiService.getGeneralPoll(this.pollID).then(response => {
        this.poll = response;
      })
    },


    getQuestions() {
      let limit = 0;
      let offset = 0;
      let filters = [];
      if (this.questionID)
        filters = [['id', this.questionID]];
      else
        filters = [['poll', this.pollID]];

      let sort = [];

      sort.push(this.sort)

      if (this.dates.length == 2) {
        if (this.dates[0] <= this.dates[1]) {
          const start = new Date(this.dates[0]);
          const end = new Date(this.dates[1]);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);

          filters.push(['start_date', start.toISOString()]);
          filters.push(['end_date', end.toISOString()]);
        } else {
          const start = new Date(this.dates[1]);
          const end = new Date(this.dates[0]);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);

          filters.push(['start_date', start.toISOString()]);
          filters.push(['end_date', end.toISOString()]);

          let tmp = this.dates[0];
          this.dates[0] = this.dates[1];
          this.dates[1] = tmp;
        }
      }

      if (this.filter_favorite)
        filters.push(['favorite', 1])

      if (this.filter_voted)
        filters.push(['voted', 0])

      apiService.getGeneralPollQuestions(sort, this.search ? this.search : "", limit, offset, filters).then((response) => {
        this.questions = response.results;
        this.count = response.count;
        this.loading = false;
      });
    }
  },
};
</script>

<style scoped>
video {
  max-width: 100%;
  height: auto;
}

.poll-actions {
  flex-wrap: wrap;
  row-gap: 8px;
}

@media (max-width: 600px) {
  .poll-actions .v-spacer {
    display: none;
  }

  .poll-actions-detail {
    flex: 1 0 100%;
  }
}
</style>
